import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FacilityId } from 'src/models/resort/Construction';
import { UserColor } from 'src/models/resort/UserColor';
import { getFacilityTheme } from '../ConstructionTheme';
import { FacilityIcon } from '../FacilityIcon';
import { ResortEmphasis } from './ResortEmphasis';
import { ResortRibbon } from './ResortRibbon';

interface ImageHeaderFacilityProps {
  freeTheme: string; // 名前
  facilityId: FacilityId; // 施設の種類
  color: UserColor;
}

export const ImageHeaderFacility = ({ freeTheme, facilityId, color }: ImageHeaderFacilityProps) => {
  const { t } = useTranslation('resort');
  const facilityTheme = getFacilityTheme(t, freeTheme, facilityId);

  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .facility-icon {
          line-height: 0;
          position: relative;
          z-index: 1;
          transform: translateY(8px);
        }
        .free-theme {
          padding: 0 8px;
        }
      `}
    >
      <div className="facility-icon">
        <ResortEmphasis color={color.textLight}>
          <FacilityIcon facilityId={facilityId} iconSize={48} />
        </ResortEmphasis>
      </div>
      <ResortRibbon color={color}>{facilityTheme}</ResortRibbon>
    </div>
  );
};
